import React from 'react';
import PropTypes from 'prop-types';

import './ProductsFormErrors.css';

function renderErrors(errors) {
  return Object.values(errors).map((error, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div key={`ProductsFormErrors__error_${index}`} className="ProductsFormErrors__error">
      {error}
    </div>
  ));
}

export default function FormErrors({ errors }) {
  return <div className="ProductsFormErrors">{renderErrors(errors)}</div>;
}
FormErrors.propTypes = {
  errors: PropTypes.object,
};
FormErrors.defaultProps = {
  errors: {},
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsFormErrors/ProductsFormErrors.jsx